module.exports = "/static/assets/48368b326f3104d353495aa5f1f76ef6.png";